import React from 'react';
import BlockUi from 'react-block-ui';
import HighlightBanner from '../../components/HighlightedBanner/HighlightBanner';
import { PlanCardsGrid } from './_components/PlanCardsGrid';
import { PlanComparisonTable } from './_components/PlanComparisonTable';
import { usePaymentPlansBootstrap } from './payment-plans.bootstrap.hook';

export function PaymentPlans() {
  const {
    plans,
    loading,
    errorMessage,
    selectedIds,
    toggleSelected,
    selectedPlans,
    comparisonRows,
  } = usePaymentPlansBootstrap();

  return (
    <>
      <h1 className="azul-cabecalho">Planos</h1>
      <p className="subheader-text mb-10">
        Planos do JusSub e os itens incluídos em cada um.
      </p>

      {errorMessage && (
        <div className="mb-6">
          <HighlightBanner type="error">{errorMessage}</HighlightBanner>
        </div>
      )}

      <BlockUi tag="div" blocking={loading}>
        {loading && <div style={{ height: '300px' }} />}
        {!loading && (
          <>
            <PlanCardsGrid
              plans={plans}
              selectedIds={selectedIds}
              onToggleSelected={toggleSelected}
            />
            <PlanComparisonTable plans={selectedPlans} rows={comparisonRows} />
          </>
        )}
      </BlockUi>
    </>
  );
}
